import { IsEmail, IsString, MinLength } from 'class-validator';
import { SigninInterface } from "../../interface/auth/signin.interface";

export class SigninDto implements SigninInterface {
  @IsEmail({}, { message: 'Email must be valid' })
  email!: string;

  @IsString()
  @MinLength(8, { message: 'Password must be at least 8 characters' })
  password!: string;
}
